import { List, Typography } from "antd";
import { useEffect, useMemo, useState } from "react";
import ReactJson from "react-json-view";
import { SpeedItemData } from "../types/types";

const { Text } = Typography;

interface IRPCSpeedItem {
  item: SpeedItemData;
}
const blocknumberReq =
  '{"jsonrpc":"2.0","method":"eth_blockNumber","params":[],"id":1}';

const syncingReq =
  '{"jsonrpc":"2.0","method":"eth_syncing","params":[],"id":1}';

const RPCSpeedItem = (props: IRPCSpeedItem) => {
  const { item } = props;
  const [speed, setSpeed] = useState(NaN);
  const [reason, setReason] = useState({});
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    if (item.url) {
      const start = Date.now();

      fetch(item.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: blocknumberReq,
      })
        .then((res) => {
          if (res.status === 200) {
            setReason({ url: item.url, status: res.status });
            res.json().then(async (content) => {
              const targetBlockNumber = parseInt(content.result, 16);
              let syncing;

              if (targetBlockNumber === 0) {
                try {
                  const res = await fetch(item.url, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: syncingReq,
                  });
                  syncing = await res.json();
                  if (syncing["result"] === "false") {
                    setReason(
                      content.result
                        ? { url: item.url, result: syncing["result"] }
                        : content
                    );
                  } else {
                    const knownStates = parseInt(
                      syncing["result"]["knownStates"],
                      16
                    );
                    const pulledStates = parseInt(
                      syncing["result"]["pulledStates"],
                      16
                    );

                    setReason(
                      content.result
                        ? {
                            url: item.url,
                            knownStates,
                            pulledStates,
                            diff: knownStates - pulledStates,
                          }
                        : content
                    );
                  }
                } catch (error) {}
              } else {
                if (item["expect"]) {
                  const res = await fetch(item["expect"] as string, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: blocknumberReq,
                  });
                  syncing = await res.json();

                  const expectedBlockNumber = parseInt(syncing["result"], 16);
                  setReason(
                    content.result
                      ? {
                          url: item.url,
                          current: targetBlockNumber,
                          chain: expectedBlockNumber,
                          diff: expectedBlockNumber - targetBlockNumber,
                        }
                      : content
                  );
                } else {
                  setReason(
                    content.result
                      ? {
                          url: item.url,
                          current: targetBlockNumber,
                        }
                      : content
                  );
                }
              }
            });
          } else {
            setHasError(true);
            setReason(res.status);
          }
        })
        .catch(() => {
          setHasError(true);
        })
        .finally(() => {
          setSpeed(Date.now() - start);
        });
    }
  }, [item]);
  const itemStatus = useMemo(() => {
    const isError = hasError || speed > 2000;
    const isWarning = !hasError && speed < 2000 && speed > 1000;
    const isNormal = !hasError && speed < 1000;
    return isError ? "🔴" : isWarning ? "🟠" : isNormal ? "🟢" : "⚪";
  }, [hasError, speed]);
  return (
    <List.Item>
      <List.Item.Meta avatar={itemStatus} title={item.name} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <ReactJson
          theme="bright"
          style={{ background: "transparent" }}
          src={reason}
          collapsed={true}
          displayObjectSize={false}
          displayDataTypes={false}
        />
        <Text type="secondary">{speed}ms</Text>
      </div>
    </List.Item>
  );
};

export default RPCSpeedItem;
